import { HashRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import VisitProfilePage from './pages/VisitProfilePage';
import AdminPanelPage from './pages/AdminPanelPage';
import UserListPage  from './pages/UserListPage';
import AboutPage from './pages/AboutPage';

function AppInit() {
  const navigate = useNavigate();

  useEffect(() => {
    // Eğer daha önce temizlenmediyse
    if (!localStorage.getItem('clearedOnce')) {
      localStorage.clear();           // tüm token ve studentId temizlenir
      localStorage.setItem('clearedOnce', 'true'); // bir daha temizlemeyecek
      navigate('/');                  // login sayfasına yönlendir
    }
  }, [navigate]);

  return null; // sadece side-effect için
}

function App() {
  return (
    <Router>
      <AppInit />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/myprofile" element={<ProfilePage />} />
        <Route path="/admin" element={<AdminPanelPage />} />
        <Route path="/userList" element={<UserListPage />} />
        <Route path="/visit-profile-id/:studentId" element={<VisitProfilePage />} />
        <Route path="/visit-profile-username/:username" element={<VisitProfilePage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
